// TODO: we can inject it
import { RestClient } from '@pegasus/rest-client';
import { getCookie } from './cookies';
export var OnboardingType;
(function (OnboardingType) {
    OnboardingType["default"] = "DEFAULT";
    OnboardingType["platformJourneyInformational"] = "PLATFORM_JOURNEY_INFORMATIONAL";
    OnboardingType["platformJourneyRelevancy"] = "PLATFORM_JOURNEY_RELEVANCY";
    OnboardingType["fashionStore"] = "FASHION_STORE";
})(OnboardingType || (OnboardingType = {}));
export const getOnboardingDetails = async () => {
    if (getCookie('zl_test_force_auto_login')) {
        return Promise.resolve({
            onboardingType: OnboardingType.fashionStore,
            voucherEligibility: true,
        });
    }
    return RestClient.get('/api/phoenix/customer/onboarding')
        .send()
        .then(response => response.json())
        .then((response) => {
        return {
            onboardingType: response === null || response === void 0 ? void 0 : response.onboarding_type,
            voucherEligibility: response === null || response === void 0 ? void 0 : response.voucher_eligibility,
        };
    })
        .catch(() => {
        return {
            onboardingType: undefined,
            voucherEligibility: false,
        };
    });
};
export const finishAutoLoginOnboarding = () => {
    return RestClient.put('/api/phoenix/customer/onboarding')
        .withPayload({
        newsletter: true,
        type: 'FASHION_STORE',
    })
        .send()
        .then(() => { });
};
//# sourceMappingURL=onbording.js.map